import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=582733cf&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=ts&"
export * from "./contact.vue?vue&type=script&lang=ts&"
import style0 from "./contact.vue?vue&type=style&index=0&id=582733cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582733cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582733cf')) {
      api.createRecord('582733cf', component.options)
    } else {
      api.reload('582733cf', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=582733cf&scoped=true&", function () {
      api.rerender('582733cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/wordpress/contact.vue"
export default component.exports